import {z} from 'zod';

import {stringToJSONSchema} from './stringToJSONSchema';

export function parseJSON<T>(json: string, schema: z.ZodType<T>) {
  return schema.parse(stringToJSONSchema.parse(json));
}
